.bar {
  position: relative;
  height: 28px;
  display: flex;
  align-items: center;
  cursor: pointer;
  touch-action: none;
  padding: 0 14px;
}

.disabled {
  cursor: default;
  opacity: 0.55;
  pointer-events: none;
}

.track {
  position: relative;
  width: 100%;
  height: 3px;
  background: rgba(255, 255, 255, 0.22);
  border-radius: 99px;
  transition: height 0.14s ease;
  overflow: hidden;
}

.bar:hover .track,
.bar:focus-visible .track {
  height: 6px;
}

@media (pointer: coarse) {
  .bar {
    height: 36px;
  }
  .track {
    height: 5px;
  }
}

.buffered {
  position: absolute;
  inset: 0 auto 0 0;
  background: rgba(255, 255, 255, 0.35);
  border-radius: 99px;
}

.played {
  position: absolute;
  inset: 0 auto 0 0;
  background: linear-gradient(90deg, #c91828, #e11d2e 40%, #ff4d5a);
  border-radius: 99px;
  z-index: 1;
  box-shadow: 0 0 12px rgba(225, 29, 46, 0.45);
}

.thumb {
  position: absolute;
  top: 50%;
  width: 14px;
  height: 14px;
  background: #fff;
  border: 2px solid #e11d2e;
  border-radius: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0.14s ease;
  z-index: 3;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.45);
}

.bar:hover .thumb,
.bar:focus-visible .thumb {
  transform: translate(-50%, -50%) scale(1);
}

.marker {
  position: absolute;
  top: 50%;
  width: 3px;
  height: 3px;
  background: #fff;
  border-radius: 1px;
  transform: translate(-50%, -50%);
  z-index: 2;
}

.chapter {
  position: absolute;
  top: 50%;
  width: 2px;
  height: 9px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 1px;
  transform: translate(-50%, -50%);
  z-index: 2;
}

.tooltip {
  position: absolute;
  bottom: 100%;
  transform: translateX(-50%);
  margin-bottom: 10px;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.thumbPreview {
  border-radius: 8px;
  overflow: hidden;
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.12),
    0 10px 28px rgba(0, 0, 0, 0.55);
  background: #000;
}

.sprite {
  background-repeat: no-repeat;
}

.timeLabel {
  background: rgba(12, 14, 18, 0.92);
  backdrop-filter: blur(10px);
  color: #fff;
  font-size: 12px;
  padding: 5px 8px;
  border-radius: 8px;
  font-variant-numeric: tabular-nums;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.chapterLabel {
  font-size: 11px;
  color: #c5c9d1;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
